export default __webpack_public_path__ + "static/media/005-fish.b2729549.svg";